export const pluginId = 'content-releases';
